import request from './request'
import appConfig from './../config/app'

export default {
  namespaced: true,
  strict: appConfig.store.strict,
  state: {
    baseURL: appConfig.services.authentication.baseURl,
    url: '/api/group',
    groupList: []
  },
  mutations: {
    setList (state, payload) {
      state.groupList = payload
    }
  },
  actions: {
    /**
     * Action to update field value
     *
     * @param {state, commit} commit
     * @param {payload} payload
     * @return void
     */
    async populateGroupList ({ state, commit }) {
      const payload = {
        baseURL: state.baseURL,
        url: state.url
      }

      await request.get({}, payload)
        .then(({ data }) => {
          commit('setList', data)
        })
        .catch(({ response }) => {
          throw response
        })
    },
    /**
     * empty listing
     *
     * @param {commit} commit
     * @return void
     */
    async clearGroupList ({ commit }) {
      commit('setList', [])
    }
  }
}
